import { render, staticRenderFns } from "./customer-analysis.vue?vue&type=template&id=24f8cd1d&scoped=true&"
import script from "./customer-analysis.vue?vue&type=script&lang=js&"
export * from "./customer-analysis.vue?vue&type=script&lang=js&"
import style0 from "./customer-analysis.vue?vue&type=style&index=0&id=24f8cd1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8cd1d",
  null
  
)

export default component.exports